import { Route } from 'react-router-dom';
import { Home, Holerite, BancoHoras, InformeRendimentos, Beneficios, AlimentacaoRefeicao, Transporte, Saude, Ferias, DetalhesPeriodo, DetalhesFerias, ConsultaProduto, BuscaProduto } from '@pages';
import { PathsEnum } from '@routes/enumerators/paths.enum';

export const colaboradorPagesRoutes = () => (
	<>
		<Route index element={<Home />} />
		<Route path={PathsEnum.HOLERITE} element={<Holerite />} />
		<Route path={PathsEnum.BANCODEHORAS} element={<BancoHoras />} />
		<Route path={PathsEnum.INFORMERENDIMENTOS} element={<InformeRendimentos />} />
		<Route path={PathsEnum.BENEFICIOS} element={<Beneficios />} />
		<Route path={PathsEnum.ALIMENTACAO} element={<AlimentacaoRefeicao />} />
		<Route path={PathsEnum.TRANSPORTE} element={<Transporte />} />
		<Route path={PathsEnum.SAUDE} element={<Saude />} />
		<Route path={PathsEnum.FERIAS} element={<Ferias />} />
		<Route path={PathsEnum.DETALHESPERIODO} element={<DetalhesPeriodo />} />
		<Route path={PathsEnum.DETALHESFERIAS} element={<DetalhesFerias />} />
	</>
);

export const varejoPagesRoutes = () => (
	<>
		<Route index element={<Home />} />
		<Route path={PathsEnum.PERFORMANCE_PRODUTO} element={<ConsultaProduto />} />
		<Route path={PathsEnum.VAREJO_PRODUTO_IMAGEM} element={<BuscaProduto />} />
	</>
);
